import {
  SAVE_USER,
  SAVE_USER_PROFILE,
  SAVE_USER_NOTIFICATION_SETTINGS,
  SAVE_USER_ACCOUNTS,
} from 'redux/constants/User';

const theme = (state = {}, action) => {
  switch (action.type) {
  case SAVE_USER:
    return {
      ...state,
      details: action.payload
    };
  case SAVE_USER_PROFILE:
    return {
      ...state,
      profile: action.payload
    };
  case SAVE_USER_NOTIFICATION_SETTINGS:
    return {
      ...state,
      notification_settings: action.payload
    };
  case SAVE_USER_ACCOUNTS:
    return {
      ...state,
      accounts: action.payload
    };
  default:
    return state;
  }
};

export default theme